import {
	nextGenBacklogPageLoad,
	uifBacklogNewUiPageLoad,
} from '../../services/utils/performance-analytics';
import { useBacklogSelector } from '../index';
import { getIsCompanyManaged } from '../selectors/app';

export const usePerformanceMetric = () =>
	useBacklogSelector(getIsCompanyManaged) ? uifBacklogNewUiPageLoad : nextGenBacklogPageLoad;
